// this function converts a text to a url slug, removing accents and spaces
import {SessionStorage} from "quasar";

export function slugify(text) {
  const diacritics = [
    {char: 'A', base: /[\300-\306]/g},
    {char: 'a', base: /[\340-\346]/g},
    {char: 'E', base: /[\310-\313]/g},
    {char: 'e', base: /[\350-\353]/g},
    {char: 'I', base: /[\314-\317]/g},
    {char: 'i', base: /[\354-\357]/g},
    {char: 'O', base: /[\322-\330]/g},
    {char: 'o', base: /[\362-\370]/g},
    {char: 'U', base: /[\331-\334]/g},
    {char: 'u', base: /[\371-\374]/g},
    {char: 'N', base: /[\321]/g},
    {char: 'n', base: /[\361]/g},
    {char: 'C', base: /[\307]/g},
    {char: 'c', base: /[\347]/g},
  ];

  diacritics.forEach(function (letter) {
    text = text.replace(letter.base, letter.char);
  });

  return text
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/&/g, '-y-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-'); // Replace multiple - with single -
}

export function getImageUrl(imageName) {
  if(!imageName) {
    return null;
  }

  if(imageName.startsWith('http')) {
    return imageName;
  }
  return process.env.API_URL + imageName;
}

// Used to bugfix introJs Scroll
export function horizontalScrollInParentTo(elementClassName, offset= 20) {
  const element = document.getElementsByClassName(elementClassName)[0]
  let style = window.getComputedStyle(element);
  const excludeStaticParent = style.position === "absolute";
  const overflowRegex = /(auto|scroll)/;

  if (style.position === "fixed") {
    return document.body;
  }

  for (let parent = element; (parent = parent.parentElement); ) {
    style = window.getComputedStyle(parent);
    if (excludeStaticParent && style.position === "static") {
      continue;
    }
    if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) {
      parent.scrollLeft = element.offsetLeft - parent.offsetLeft - offset;
      return;
    }
  }
}

export function getCreatedFrom(query) {
  const utmSource = query.utm_source;
  const utmCampaign = query.utm_campaign;
  const cid = query.cid;
  let createdFrom = null;

  if (utmSource) {
    if (utmCampaign) {
      createdFrom = `${utmSource}_${utmCampaign}`;
    }
    else if (cid) {
      createdFrom = `${utmSource}_${cid}`;
    }
    else {
      createdFrom = `${utmSource}`;
    }
  }

  if (createdFrom === null) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('utm_source')) {
      if (urlParams.get('utm_campaign')) {
        createdFrom = `${urlParams.get('utm_source')}_${urlParams.get('utm_campaign')}`
      }
      else if (urlParams.get('cid')) {
        createdFrom = `${urlParams.get('utm_source')}_${urlParams.get('cid')}`
      }
      else {
        createdFrom = `${urlParams.get('utm_source')}`
      }
    }
  }

  SessionStorage.set('created_from', createdFrom);

  return createdFrom;
}

export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}

export function mapToObject(map) {
  const obj = {};
  for (const [key, value] of map) {
    obj[key] = value;
  }
  return obj;
}

export const isSameDay = (date1, date2) => {
  return date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate();
};

export const getAssetItem = (url) => {
  return process.env.ASSETS_URL + url
}